import { Controller } from "@hotwired/stimulus"

/**
 * CardRevealController - Animation stagger au chargement des cards
 *
 * Tendance Design 2026: animations d'entrée fluides et naturelles
 * Les cards apparaissent en cascade avec un léger décalage (stagger)
 *
 * Usage:
 *   <div data-controller="card-reveal">
 *     <div data-card-reveal-target="card">Card 1</div>
 *     <div data-card-reveal-target="card">Card 2</div>
 *   </div>
 *
 * Accessibilité: respecte prefers-reduced-motion
 */
export default class extends Controller {
  static targets = ["card"]

  static values = {
    staggerDelay: { type: Number, default: 60 },
    duration: { type: Number, default: 500 },
    translateY: { type: Number, default: 20 }
  }

  connect() {
    this.revealCards()
  }

  revealCards() {
    // Respect reduced motion preference for accessibility
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return
    }

    this.cardTargets.forEach((card, index) => {
      // Initial state: invisible and translated down
      card.style.opacity = "0"
      card.style.transform = `translateY(${this.translateYValue}px)`

      // Stagger animation with delay based on index
      setTimeout(() => {
        card.style.transition = `opacity ${this.durationValue}ms ease-out, transform ${this.durationValue}ms ease-out`
        card.style.opacity = "1"
        card.style.transform = "translateY(0)"
      }, index * this.staggerDelayValue)
    })
  }

  // Optional: re-trigger animation (useful for Turbo Stream updates)
  reveal() {
    this.revealCards()
  }
}
